// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"22d0e171a8628634c11c","777":"b3078077af5f107a82d8"}[chunkId] + ".bundle.js";
};